<!--  -->
<template>
  <div>
    <div>
      <el-input v-model="pagequery.title" class="titiltip" placeholder="请输入标题" />
      <el-input v-model="pagequery.customer_message_no" class="titiltip" placeholder="请输入编号" />
      <el-select v-model="pagequery.msg_type" class="titiltip" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select v-if="type == 1" v-model="messageparid" placeholder="请选择平台" @change="messagechange">
        <el-option
          v-for="items in plateoption"
          :key="items.id"
          :label="items.name"
          :value="items.id"
        />
      </el-select>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="primary" @click="reast">重置</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="customer_message_no"
        label="编号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="所属平台"
        width="100"
        align="center"
      />
      <el-table-column
        prop="title"
        label="标题"
        width="180"
        align="center"
      />
      <el-table-column
        prop="msg_type_str"
        label="类型"
        width="100"
        align="center"
      />
      <el-table-column
        prop="creator"
        label="创建人"
        width="100"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="150"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="chooser(scope.row)">选择</el-button>
          <el-button type="primary" size="small" @click="prwiedit(scope.row)">预览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="templatetotalre"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />

    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <PreviewDialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import { customercreatlist, customermessagelist, strategyPlatform } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import PreviewDialog from '../../timedPush/components/PreviewDialog'
export default {
  components: { PaginationRight, PreviewDialog },
  data() {
    return {
      tableData: [],
      options: [],
      templatetotalre: null,
      priwdialogVisible: false,
      pagequery: {
        page: 1,
        pageSize: 10,
        title: '',
        customer_message_no: null,
        msg_type: null,
        platform_id: null
      },
      type: null,
      plateoption: [],
      messageparid: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async typelist() {
      const data = await customermessagelist()
      this.options = data.data.list
      console.log('data', data)
    },
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.plateoption = data.data.list
      console.log('获取策略平台', data)
    },
    async customercreatlistall() {
      const data = await customercreatlist(this.pagequery)
      this.tableData = data.data.list
      this.templatetotalre = data.data.total
      console.log('data', data)
    },
    chooser(item) {
      this.$emit('kefucallback', item)
    },
    prwiedit(item) {
      console.log('item', item)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item, 1)
      }, 100)
    },
    send(val) {
      console.log(val, '平台id')
      // eslint-disable-next-line eqeqeq
      if (val == 99) {
        this.type = 1
        this.pagequery.platform_id = null
        this.getstrategyplatform()
        this.customercreatlistall()
      } else {
        this.pagequery.platform_id = val
        this.customercreatlistall()
      }

      this.typelist()
    },
    fetchPageSizeone(e) {
      this.pagequery.pageSize = e
      this.customercreatlistall()
    },
    fetchCurrentPageone(e) {
      this.pagequery.page = e
      this.customercreatlistall()
    },
    search() {
      this.pagequery.page = 1
      this.customercreatlistall()
    },
    reast() {
      this.pagequery.page = 1
      this.pagequery.title = ''
      this.pagequery.customer_message_no = null
      this.pagequery.msg_type = null
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        this.pagequery.platform_id = null
        this.messageparid = null
      }
      this.customercreatlistall()
    },
    messagechange(val) {
      this.pagequery.platform_id = val
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.titiltip{
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
